import {
  CREATE_ASSET_SERVICE_SUCCESS,
  CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS,
  FETCH_ASSET_SERVICE_SUCCESS,
  GET_ASSET_SERVICE_SUCCESS,
  GET_COMPLAINT_BY_ASSET_SUCCESS,
  GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS,
  SAVE_ASSET_SERVICE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  complaints: [],
  edit: {},
  query: {},
  complaintData: {},
  equipmentSubTypeData: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ASSET_SERVICE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_ASSET_SERVICE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_ASSET_SERVICE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_ASSET_SERVICE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case GET_COMPLAINT_BY_ASSET_SUCCESS: {
      return {
        ...state,
        complaints: action.data,
      }
    }

    case GET_EQUIPMENT_SUB_TYPE_DATA_SUCCESS: {
      return {
        ...state,
        equipmentSubTypeData: action.data,
      }
    }

    case CREATE_COMPLAINT_BY_ASSET_SERVICE_SUCCESS: {
      return {
        ...state,
        complaintData: action.data,
      }
    }


    default:
      return state;
  }
}
